import en from './locales/en.json';
import enGB from './locales/en-GB.json';
import enIE from './locales/en-IE.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import es from './locales/es.json';
import it from './locales/it.json';
import nl from './locales/nl.json';
import sv from './locales/sv.json';
import no from './locales/no.json';
import da from './locales/da.json';
import pt from './locales/pt.json';
import enAU from './locales/en-AU.json';
import fi from './locales/fi.json';

/** UI locale per URL region — matches admin language sidebar countries (not necessarily same BCP47 as SEO hreflang). */
const REGION_TO_LOCALE = {
  us: 'en',
  gb: 'en-GB',
  au: 'en-AU',
  ie: 'en-IE',
  de: 'de',
  at: 'de',
  es: 'es',
  it: 'it',
  fr: 'fr',
  pt: 'pt',
  nl: 'nl',
  no: 'no',
  fi: 'fi',
  dk: 'da',
  se: 'sv',
};

const DICTS = {
  en,
  'en-GB': enGB,
  'en-IE': enIE,
  'en-AU': enAU,
  fr,
  de,
  es,
  it,
  nl,
  sv,
  no,
  da,
  pt,
  fi,
};

export function localeFromRegion(region) {
  const key = String(region || '').toLowerCase();
  return REGION_TO_LOCALE[key] || 'en';
}

export function t(locale, key, fallback = '') {
  const dict = DICTS[locale] || DICTS.en;
  return dict[key] || DICTS.en[key] || fallback || key;
}

export const SUPPORTED_LOCALES = Object.keys(DICTS);
